import { atom } from 'recoil';

export const SidebarShadowState = atom({
    key: 'SidebarShadowState', 
    default: true, 
});